import { useEffect } from 'react';
import { fireServedSectionInPdp } from '../../TuesdaySale/saleInstrumentation';
import CountDown from '../TimerWithCTA/CountDown';
import {
  CountDownBox,
  FlexSection,
  TimerContainer,
  TimerHeading,
} from '../TimerWithCTA/styled';

export default function Timer(props) {
  const { data, productData } = props;
  const colors = data?.gradientList?.join(',');
  //const { pricingParam, conversionParam } = getPriceParams(productData);
  useEffect(() => {
    fireServedSectionInPdp(
      data,
      // pricingParam,
      // conversionParam,
      // productData,
    );
  }, []);

  return (
    <TimerContainer bgColor={colors} showNameLeft={true} timerOnPdp={true}>
      <FlexSection>
        <CountDownBox timerOnPdp={true}>
          <TimerHeading timerOnPdp={true}>{data?.heading}</TimerHeading>
          <CountDown data={data} showNameLeft={true} timerOnPdp={true} />
        </CountDownBox>
      </FlexSection>
    </TimerContainer>
  );
}
